import { COLORS } from 'helpers/globals'

export default {
  "button, input[type='button'], input[type='reset'], input[type='submit']": {
    backgroundColor: COLORS.primary,
    color: '#fff',
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: '1.1rem',
    letterSpacing: '.05em',
    lineHeight: '2em',
    border: '0',
    padding: '0 1em',
    textAlign: 'center',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:focus, &:hover': {
      backgroundColor: COLORS.primaryHover,
      color: '#fff',
      outline: 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/button.js